<top-banner variant="custom">
    <h2 class="title mb-3">Contractor Managers</h2>
    <button type="button" (click)="toggleCreateUserModal();" class="btn color_blue-btn btn-round"><i class="fas fa-plus"></i>
      &nbsp;
      <strong>CREATE NEW CONTRACTOR MANAGER</strong>
    </button>
</top-banner>


<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <div class="form-row">
            <!-- Search and Sorting/Filter sidemenu button to be implemented here -->
            <div class="col-md-9">
              <select class="form-control my-3" style="width: auto;" [(ngModel)]="selectedSort" (ngModelChange)="sortChange($event)">
                <option *ngFor="let option of sortFields" [ngValue]="option">
                  {{option.sortName}}
                </option>
              </select>
            </div>
            <div class="col-md-3"></div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p-table [value]="users" selectionMode="single" [(selection)]="selectedUser" (onRowSelect)="onRowSelect($event)">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="table-cell-centered">Activated</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Login</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user>
                  <tr [pSelectableRow]="user">
                    <td class="table-cell-centered">
                      <i *ngIf="user.activated" class="fas fa-check-circle success"></i>
                      <i *ngIf="!user.activated" class="fas fa-times-circle danger"></i>
                    </td>
                    <td>{{user.firstName}}</td>
                    <td>{{user.lastName}}</td>
                    <td>{{user.email}}</td>
                    <td>{{user.login}}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="4">
                      No users found
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator #paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="New Support User" [(visible)]="createUserModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="createUserForm" (ngSubmit)="onCreateUserFormSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>First Name</label>
          <input type="text" class="form-control" formControlName="firstName" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Last Name</label>
          <input type="text" class="form-control" formControlName="lastName" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Email</label>
          <input type="email" class="form-control" formControlName="email" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Login</label>
          <input type="text" class="form-control" formControlName="login" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Password</label>
          <input type="password" class="form-control" formControlName="password" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Repeat Password</label>
          <input type="password" class="form-control" formControlName="rPassword" placeholder="">
        </div>
      </div>
      <div class="col-md-12">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="createUserModal=false" class="my-2 btn btn-round btn-sm  btn-default float-left">Cancel</button>
    <button type="button" (click)="onCreateUserFormSubmit()" [disabled]="!createUserForm.valid" class="my-2 btn btn-round btn-sm btn-success">Create</button>
  </p-footer>
</p-dialog>

<p-dialog header="Edit Contractor Manager" [(visible)]="editUserModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="editUserForm" (ngSubmit)="onEditUserFormSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>First Name</label>
          <input type="text" class="form-control" formControlName="firstName" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Last Name</label>
          <input type="text" class="form-control" formControlName="lastName" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Email</label>
          <input type="email" class="form-control" formControlName="email" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Login</label>
          <input type="text" class="form-control" formControlName="login" placeholder="">
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="editUserModal=false" class="my-2 btn btn-round btn-sm  btn-default float-left">Cancel</button>
    <button type="button" (click)="onEditUserFormSubmit()" [disabled]="!editUserForm.valid" class="my-2 btn btn-round btn-sm btn-success">Save</button>
  </p-footer>
</p-dialog>
